import { createContext } from "react";

const IntlContext = createContext(null)

export default IntlContext
